/***
 * @Author: ZhaoG
 * @Date: 2025-04-10 18:34:16
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-17 16:58:35
 * @FilePath: \sra-fe\src\i18n\locale\zh-CN.js
 * @Description:
 */

export default {
  locale: "zh-CN",
  language: "简体中文",
  menu: {
    i18n: "多语言"
  },
  page: {
    supReg: {
      title: "注册",
      stepName: [
        "注册流程",
        "入网供应商须知",
        "恪守商业道德协议",
        "申请用户名",
        "供应商基本信息",
        "联系信息",
        "产品信息",
        "财务信息",
        "历史合作业绩",
        "绿色低碳",
        "资质文件"
      ],
      contentTitle: [
        "1、请仔细阅读入网供应商须知",
        "2、阅读并同意《恪守商业道德协议》",
        "3、申请用户名",
        "4、填写详细信息，上传资质文件（*为必填项）",
        "5、确认信息，提交，进入审核，审批流程",
        "6、代理人注册"
      ],
      contentP: [
        "",
        "勾选“已阅读并同意《恪守商业道德协议》”",
        "按需求申请用户名，填写联系人详细信息，选择推荐单位",
        "认真填写供应商详细信息并上传相关的资质文件，以备查询",
        "确认填写信息准确无误后，点击“提交”按钮",
        "代理人代为注册时，需上传加盖企业公章的官方授权委托书，仅支持PDF格式。"
      ],
      contentP6: "下载授权书"
    },
    supNotice: {
      contentTitle: "入网供应商须知",
      contentP: [
        "1. 中交集团供应链管理信息系统是供应商加入中国交通建设集团有限公司（以下简称“中交集团”）供应商网络的唯一合法网站。中交集团按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。",
        "2. 中国交通建设集团有限公司对申请入网的供应商不收取任何费用，也不以年审、会员制、业绩考核等名义向供应商收取费用。供应商填写入网信息必须真实、准确并及时更新。",
        "3.如遇系统升级，平台运营方有权延长招标结束时间、售标结束时间。"
      ]
    },
    moralAgree: {
      contentTitle:
        "各供应商：为了进一步规范商业行为，请仔细阅读《恪守商业道德协议》。",
      contentH: [
        "恪守商业道德协议",
        "甲方：中国交通建设集团有限公司",
        "乙方：",
        "第一条 甲乙双方共同责任",
        "第二条 中国交通建设集团有限公司",
        "第三条",
        "第四条 违约责任",
        "第五条 本协议经双方签署后生效",
        "第六条 甲乙双方及其人员在经济合同履行完毕后，发生或发现违反本协议规定的行为，仍按本协议规定处理。"
      ],
      contentP: [
        "为规范甲乙双方的商业行为，维护公平竞争，建立健全恪守商业道德的长效机制，深入推进反腐倡廉工作，根据国家有关法律法规和中国交通建设集团有限公司（以下简称“中交集团”）有关规定，经双方协商，签订恪守商业道德协议。",
        "（一）严格遵守国家有关法律法规以及廉洁从业的有关规定。",
        "（二）甲乙双方均应推进内部反腐败合规体系建设，鼓励建立反贿赂管理制度、配套廉洁培训与内部监督机制；甲方将乙方廉洁内控建设及落实情况纳入供应商信用综合评价维度。",
        "（三）严格遵守商业道德和市场规则，共同营造公平公正的商务交易环境",
        "（四）加强有关人员的管理和恪守商业道德教育，自觉抵制不廉洁行为。在商务活动中发现对方存在违规违纪违法行为，应及时向对方监察部门或司法机关举报",
        "（一）不得索要或接受乙方及其相关单位和人员提供的回扣、礼金、有价证券、支付凭证、贵重物品等。",
        "（二）不得在乙方及其相关单位报销任何应由甲方或个人支付的费用。",
        "（三）不得违反规定在乙方及其相关单位投资入股，不得向乙方单位及人员借款或委托买卖股票、债券等。",
        "（四）不得要求、暗示和接受乙方及其相关单位和个人为其购买或装修住房、婚丧嫁娶、配偶和子女的上学或工作安排以及出国（境）、旅游等提供方便。",
        "（五）不得参加乙方及其相关单位安排的可能影响公正执行公务的宴请及健身、娱乐等活动。",
        "（六）不得接受乙方及其相关单位购置或提供的通讯工具、交通工具和高档办公用品。",
        "（七）不得利用职权通过乙方及其相关单位为其配偶、子女及他人谋取不正当利益。",
        "（八）不得违反规定在乙方或乙方相关单位兼职和领取兼职工资及报酬；不得利用甲方的商业秘密、业务渠道等谋取个人私利，或将其提供泄漏给乙方及其它企业和个人。",
        "（九）不得利用职权和工作之便向乙方提出上述各项规定禁止事项或要求之外的与工作业务无关的事项或要求。",
        "（一）不得向甲方及其人员提供回扣、礼金、有价证券、支付凭证、贵重物品等。",
        "（二）不得为甲方及其人员报销应由甲方或个人支付的费用。",
        "（三）不得为甲方人员投资入股、个人借款或买卖股票、债券等提供方便。",
        "（四）不得为甲方人员购买或装修住房、婚丧嫁娶、配偶子女上学或工作安排以及出国（境）、旅游等提供方便。",
        "（五）不得为甲方人员安排有可能影响公正执行公务的宴请、健身、娱乐等活动。",
        "（六）不得为甲方及其人员购置或提供通讯工具、交通工具和高档办公用品",
        "（七）不得为甲方人员的配偶、子女及其他亲属谋取不正当利益提供方便。",
        "（八）不得违反规定安排甲方人员在乙方或乙方相关企业兼职和领取兼职工资及报酬；不得利用非法手段向甲方人员打探有关涉及甲方的商业秘密、业务渠道等。",
        "（九）甲方对涉嫌不廉洁的商业行为进行调查时，乙方有配合甲方提供证据、作证的义务。",
        "（十）确保提供的资质文件、财务报表、历史合作业绩等资料均为真实有效，不存在弄虚作假、欺骗、伪造、变造等情况。",
        "（十一）遵守质量诚信，确保合同供应产品的质量、数量符合要求，手续合法完备。主动支持和配合中交集团及其所属单位组织的履约验收工作。",
        "（十二）遵守价格诚信。确保合同供应的产品和服务成交价格不高于该产品和服务的同期市场价格；保证相同条件下为中交集团及其所属单位供应的产品和服务价格基本相同。",
        "（十三）自觉遵守和严格履行合同，不擅自变更或终止合同，确保所供应的产品符合合同要求。",
        "（十四）遵守服务诚信。不断增强服务意识，改进服务态度，提高服务质量，为中交集团及其所属单位提供及时、便捷、周到的技术支持与服务，及时妥善解决售前、售中、售后过程中出现的各种问题。",
        "（十五）遵守保密协议。未经中交集团及其所属单位同意，不得向第三方透露在合作期间获得和知晓的商业机密。",
        "（十六）未经甲方书面同意，乙方不得向任何新闻媒体、第三人述及有关中交集团恪守商业道德方面的评价、信息。",
        "（一）甲方及其人员有违反本协议第一条、第二条规定的，按照管理权限，依据有关法律法规和规定给予有关人员纪律处分或组织处理；涉嫌犯罪的，移交司法机关追究刑事责任。",
        "（二）乙方及其人员有违反本协议第一条、第三条规定的，对属于中交集团管理的单位，按照管理权限，依据国家法律法规和有关规定给予纪律处分或组织处理；涉嫌犯罪的，移交司法机关追究刑事责任。 对不属于中交集团管理的单位，根据具体情节和造成的后果，甲方除有权要求乙方赔偿由此造成的甲方损失外，还将分别在中交集团及其所属单位的注册供应商范围内给予通报或解除合作关系的处理；涉嫌犯罪的，建议司法机关追究刑事责任。",
        "甲乙双方通过招投标或其他方式签订交易合同的，本协议作为双方所有交易合同的附件，与合同具有同等法律效力；如双方未签订交易合同， 本协议独立有效。"
      ],
      errMsg: ["请先勾选已阅读并同意恪守商业道德协议"],
      contentCheckbox: ["已阅读并同意恪守商业道德协议"]
    },
    applyUsername: {
      contentTitle: {
        loginInfo: "登录账号和密码",
        contacts: "联系人和联系方式",
        reCompany: "推荐单位",
        promptTitle: "该供应商已完成平台注册",
        promptContent: "可前往登陆页面使用账号密码登录；若忘记账号和密码，可提交找回申请",
        promptContent1: "您的供应商注册申请已被初始推荐单位退回，请前往登录页面输入账号密码登录，查看具体退回原因，修改完善后重新提交；若忘记账号或密码，可提交找回申请。",
      },
      contentTitles: {
        contactsWay: "固定电话、手机和E-mail为重要联系方式，请务必认真填写",
        reCompanyMsg:
          "请慎重选择推荐单位。推荐单位为供应商注册的初审单位，选择后将不可更改。"
      },
      contentLabel: {
        supName: "供应商名称:",
        supNameEn: "供应商英文名称:",
        id: "登录账号:",
        authCode: "验证码:",
        pwd: "密码:",
        repwd: "重复输入密码:",
        contacts: "联系人:",
        contactsTel: "联系人固定电话:",
        contactsFax: "联系人传真:",
        contactsMobile: "联系人手机:",
        contactsInfo: "联系人和联系方式",
        contactsEmail: "联系人邮箱:",
        provinces: "省市地区:",
        servicesScope: "服务范围:",
        reCompany: "推荐单位:",
        mobile: "手机号:",
        ID: "证件号:",
        username: "用户名",
        type: "证件类型:",
        IDFront: "身份证国徽面:",
        IDBack: "身份证人像面:"
      },
      inputPlc: {
        supNameMSg: "请输入供应商名称",
        supNameEnMSg: "请输入供应商英文名称", 
        idMsg: "请输入登录账号，支持字母或字母数字结合",
        authCodeMsg: "请输入短信验证码",
        pwdMsg: "8-16位大小写字母,特殊字符和数字的结合",
        repwdMsg: "请再次输入密码",
        contactsMsg: "请输入联系人姓名",
        contactsTelMsg: "请输入区号和固定电话号码，例：“010-******”",
        contactsFaxMsg: "请输入区号和传真号码，例:“010-********”",
        contactsMobileMsg: "请输入正确的手机号码",
        contactsEmailMsg: "请输入E-mail",
        IDMsg: "请输入联系人身份证号/境外社保号",
        IDMSGValidate: "请输入正确的身份证号码",
        provincesMsg: "请选择省市地区",
        servicesScopeMsg: "请选择服务范围",
        reCompanyMsg: "请选择推荐单位",
        cerType: "请选择证件类型"
      },
      inputRules: {
        pwdMsg1: "长度在8到16个字符",
        pwdMsg2: "密码中必须包含大小字母、数字、特称字符",
        repwdMsg: "两次输入的密码不一致",
        contactsMsg: "姓名格式不正确",
        contactsTelMsg:
          "联系人固定电话格式不正确(格式：区号+号码，如010-1234567)",
        contactsFaxMsg: "联系人传真格式不正确(格式：区号+号码，如010-1234567)",
        contactsMobileMsg: "手机号格式不正确",
        contactsEmailMsg: "邮箱格式不正确",
        provincesMsg: "请选择省市地区",
        sliderMsg: "请先输入手机号",
        reCompanyMsg: "推荐单位不能为空",
        reCompanyMsg1: "推荐单位不存在",
        reCompanyMsg2: "请输入非集团总部单位",
        supNameMSg: "供应商名称不能为空",
        supNameMSg1: "该供应商名称已存在",
        codemsg: "验证码不能为空",
        mobilemsg: "手机号不能为空",
        mobilemsg1: "该手机号已存在"
      },
      btn: {
        getCode: "获取验证码",
        msg1: "请按住滑块，拖动到最右侧",
        msg2: "验证通过",
        msg3: "加载中",
        msg4: "验证不通过",
        msg5: "哎呀出错了，点击",
        msg6: "刷新",
        msg7: "再来一次",
        msg8: "网络不给力，请",
        msg9: "点击刷新",
        msg10: "我已注册，查看审批进展",
        promptbutton1: "找回密码",
        promptbutton2: "立即登录"
      },
      dialogMsg: {
        msg1: "您现在选择的推荐单位是",
        msg2: ",推荐单位负责审核您公司的注册信息。请仔细核对，避免出错！",
        title: "提示",
        msg3: "系统将为您保留注册信息 72 小时；若超时未提交注册申请，系统将自动删除相关注册数据（删除后不可恢复）"
      },
      others: {
        IDCard: "身份证",
        aboardIDCard: "境外社保"
      },
      supplierTypeDialogMsg: {
        title: "请选择供应商类型",
        title1: "已选供应商类型",
        placeholderMsg: "输入关键字进行过滤"
      }
    },
    supInfo: {
      contentTitle: {
        basicInfo: "基本信息",
        producer: "生产商（填写）",
        dealer: "经销商（填写）"
      },
      contentLabel: {
        supName: "供应商名称:",
        abbreviation: "简称:",
        supType: "供应商类型:",
        hisName: "历史名称:",
        isForeign: "是否为外贸供应商:",
        isInside: "是否为中交内部单位:",
        isThree: "是否三证合一:",
        unifyCode: "统一社会信用代码:",
        GATunifyCode: "港澳台统一代码证:",
        framework: "组织机构代码:",
        organization: "组织机构代码证件有效期:",
        dutyParagraph: "税号:",
        domicile: "住所:",
        businessAddress: "办公地址:",
        postcode: "邮编:",
        registeredCapital: "注册资本(万元):",
        currency: "币种:",
        capital: "实收资本(万元):",
        UniProperty: "单位性质",
        companyType: "公司类型:",
        businessScope: "经营范围:",
        foundingTime: "成立时间:",
        businessTerm: "营业期限:",
        organizationChart: "组织架构及营销网络:",
        companyName: "所属集团公司名称:",
        companyProfile: "公司简介:",
        capacity: "产能:",
        processStatus: "工艺技术状况:",
        manufacturer: "所销售产品的生产商名称:",
        qualification: "销售代理资格:",
        userInfo: "登录账号和密码",
        country: "注册国家",
        business: "营业执照号",
        organiza: "分支机构及联系方式",
        unitCategory: "单位类别",
        abroadSocialSecurity: "境外社保号"
      },
      inputPlc: {
        supName: "请输入供应商名称",
        abbreviation: "请输入简称",
        unitCategory: "请输入单位类别",
        hisName: "请输入历史名称",
        choose: "请选择",
        yes: "是",
        no: "否",
        unifyCode: "请输入统一社会信用代码",
        GATunifyCode: "请输入港澳台统一代码证",
        framework: "请输入组织机构代码",
        chooseDate: "选择日期",
        dutyParagraph: "请输入税号",
        domicile: "请输入住所",
        businessAddress: "请输入办公地址",
        UniProperty: "请选择单位性质",
        postcode: "请输入邮编",
        registeredCapital: "请输入注册资本",
        capital: "请输入实收资本",
        input: "请输入",
        country: "请选择国别",
        business: "请输入营业执照号",
        organiza: "请输入分支机构及联系方式",
        personal: "个人",
        company: "单位",
        abroadSocialSecurity: "请输入境外社保号"
      },
      inputRules: {
        supType: "请选择供应商类型",
        choose: "请选择是或否",
        chooseDate: "请填写完整日期",
        chooseCurrency: "请选择币种",
        conpanyType: "请选择公司类型",
        businessScope: "请输入经营范围",
        foundingTime: "请选择成立时间",
        businessTerm: "请选择营业期限",
        max: "最大不能超过6位",
        postcode: "邮编格式不正确",
        organizationChart: "请输入组织架构及营销网络",
        companyProfile: "请输入公司简介",
        unitCategoryType: "请选择单位或个人",
        abroadSocialSecurity: "请输入境外社保号"
      }
    },
    contactInfo: {
      contentTitle: { contactsInfo: "联系信息" },
      contentLabel: {
        legalName: "法人代表姓名:",
        controlAgent: "实控主体:",
        xuhao: "序号",
        controlType: "实控类型",
        controlId: "控制主体代码或证件号",
        legalMobile: "法人代表手机:",
        saleID: "销售负责人身份证号/境外社保号:",
        legalTel: "法人代表固定电话:",
        legalID: "证件号:",
        legalFax: "法人代表传真:",
        legalEmail: "法人代表邮箱:",
        market: "销售负责人:",
        marketMobile: "销售负责人手机:",
        marketTel: "销售负责人固定电话:",
        marketFax: "销售负责人传真:",
        marketEmail: "销售负责人邮箱:",
        web: "公司网址:",
        DJG: "董监高",
        DJGT: "董监高类型",
        DJGN: "董监高人员姓名",
        DJGID: "董监高人员证件号"
      },
      inputPlc: {
        legalNameMsg: "请输入法人代表姓名",
        legalMobileMsg: "请输入法人代表手机号码",
        saleID: "请输入销售负责人身份证号/境外社保号",
        legalID: "请输入法人代表身份证号/境外社保号",
        legalTelMsg: "请输入法人代表区号和固定电话号码，例:“010-********”",
        legalFaxMsg: "请输入法人代表区号和传真号码，例:“010-********”",
        legalEmailMsg: "请输入法人代表电子邮箱地址",
        marketMsg: "请输入销售负责人姓名",
        marketMobileMsg: "请输入销售负责人手机号码",
        marketTelMsg: "请输入销售负责人区号和固定电话号码，例:“010-********”",
        marketFaxMsg: "请输入销售负责人区号和传真号码，例:“010-********”",
        marketEmailMsg: "请输入销售负责人电子邮箱地址",
        webMsg: "请输入网址"
      },
      inputRules: {
        mobileMsg: "手机号格式不正确",
        legalTelMsg:
          "法人代表固定电话格式不正确(格式：区号+号码，如010-1234567)",
        legalFaxMsg: "法人代表传真格式不正确(格式：区号+号码，如010-1234567)",
        marketTelMsg:
          "销售负责人固定电话格式不正确(格式：区号+号码，如010-1234567)",
        marketFaxMsg:
          "销售负责人传真格式不正确(格式：区号+号码，如010-1234567)",
        emailMsg: "邮箱格式不正确"
      }
    },
    productInfo: {
      contentTitle: { productInfo: "产品信息" },
      tableTh: {
        productCode: "产品编码",
        productName: "产品名称",
        productTrademark: "产品商标",
        remark: "备注",
        operation: "操作"
      },
      btn: {
        add: "添加",
        newAdd: "新增",
        batchDel: "批量删除",
        del: "删除",
        cancel: "取消",
        confirm: "确定"
      },
      dialog: {
        info: "提示",
        title: "设备物资选择",
        inp: "请输入",
        nextMsg: "请选择至少一条产品信息"
      },
      delInfo: {
        batchDelInfo: "请选择至少一条数据进行删除",
        delInfo: "此操作将永久删除该文件，是否继续",
        confirmDel: "删除成功",
        cancelInfo: "已取消删除"
      }
    },
    financeInfo: {
      contentTitle: { financeInfo: "财务信息" },
      contentLabel: {
        bankAccount: "银行账号:",
        depositBank: "开户银行:",
        bankAccountName: "银行账户名称",
        bankAddress: "银行地址",
        beneficiary: "收款人地址",
        swiftCode: "银行国际代码",
        isWhether: "是否接收信用卡付款"
      },
      inputPlc: {
        bankAccountMsg: "请输入银行账号",
        depositBankMsg: "请输入开户银行",
        bankAccountNameMsg: "请输入银行账户名称",
        bankAddressMsg: "请输入银行地址",
        beneficiaryMsg: "请输入收款人地址",
        swiftCodeMsg: "请输入银行国际代码",
        isWhetherMsg: "请选择是或否"
      }
    },
    hisCooperation: {
      contentTitle: { hisCooperation: "历史合作业绩" },
      contentLabel: {
        cooperationCompany: "合作企业:",
        cooperationPerformance: "与中交合作业绩:",
        peerCooperation: "与同行业企业合作业绩:",
        remark: "备注:"
      },
      inputPlc: { input: "请输入", cooperationCompanyMsg: "请输入合作企业" }
    },
    greenLowCarbon: {
      contentTitle: {
        greenLowCarbon: "绿色低碳",
        greenProduction: "绿色生产",
        greenProducts: "绿色产品",
        greenLogistics: "绿色物流",
        carbonManagement: "碳管理"
      },
      contentLabel: {
        isGreenLowCarbon: "本企业是否涉及绿色低碳管理：",
        isGreenProduction: "是否获得绿色工厂认证：",
        isGreenLogistics: "是否获得绿色物流认证：",
        isZeroCarbonFactoryCertification: "是否获得零碳工厂认证：",
        isEnterprisesPassTheCleanProductionAudit: "是否通过企业清洁生产审核：",
        isEnvironmentallyFriendlyProductionProcess:
          "是否使用新型干法等环保性生产工艺：",
        isProductEnergyConsumption: "轧钢单位产品能源消耗量：",
        isProductEnergyConsumptionPlaceholder: "轧钢单位产品能源消耗量",
        isAsphaltProductEnergyConsumption: "沥青生产单位产品能源消耗：",
        isAsphaltProductEnergyConsumptionPlaceholder:
          "沥青生产单位产品能源消耗",
        isZeroCarbonFactoryCertificationRating: "零碳工厂认证星级：",
        isGreenProductionRating: "绿色物流认证星级：",
        isGreenProductionRatingPlaceholder: "绿色物流认证星级",
        isYes: "是",
        isNo: "否",
        changeCategory: "请选择类别：",
        greenFactoryCertificationLevel: "绿色工厂认证等级：",
        greenFactoryCertificationFile:
          "上传对应的【绿色工厂认证证书/铭牌】附件：",
        ZeroCarbonFactoryCertificationRatingFile:
          "上传对应的【零碳工厂认证证书/铭牌】附件：",
        EnterprisesPassTheCleanProductionAuditFile:
          "上传的【清洁生产审核报告（备案本）】附件：",
        EnvironmentallyFriendlyProductionProcessFile:
          "上传对应的【生产工艺设计说明/流程说明】附件：",
        ProductEnergyConsumptionFile:
          "上传对应的【单位产品能源消耗计算书】附件：",
        greenFactoryCertificationLevelPlaceholder: "绿色工厂认证等级",
        isZeroCarbonFactoryCertificationRatingPlaceholder: "零碳工厂认证星级",
        changeCategoryPlaceholder: "请选择类别",
        changeCategoryMsg: "请选择类别",
        uploadErr1:
          "上传文件格式不正确，请重新上传",
        uploadErr2: "上传文件大小不能超过 15M!",
        changeCategoryOption: [
          {
            label: "不选择",
            value: "1"
          },
          {
            label: "水泥",
            value: "2"
          },
          {
            label: "钢材",
            value: "3"
          },
          {
            label: "沥青",
            value: "4"
          }
        ],
        peerCooperation: "与同行业企业合作业绩:",
        remark: "备注:",
        AdoptingMethodsOfResourceRecyclingSuchAsRawMaterialSubstitution:
          "是否采用原材料替代等资源循环利用方式：",
        RawMaterialSubstitutionRate: "原材料替代率：",
        productionRawMaterialSubstitutionRate:
          "上传对应的【生产原料替代率计算书】附件：",
        RawMaterialSubstitutionRatePlaceholder: "原材料替代率",
        steelRollingProcess: "是否对轧钢过程进行废钢余料回收再利用：",
        ScrapSteelRecyclingPlanFile:
          "上传对应的【废钢循环利用方案、计算书】附件：",
        IsRecyclingOfRawMaterialsForAsphaltProductionConducted:
          "是否对沥青生产原材料进行回收利用：",
        RawMaterialRecyclingAndUtilizationRate: "原材料回收利用率：",
        RawMaterialRecyclingAndUtilizationRatePlaceholder: "原材料回收利用率：",
        CalculationSheetForRawMaterialRecyclingUtilizationRate:
          "上传对应的【原材料回收利用率计算书】附件：",
        IsWasteAsphaltRecycledAndReused: "是否对废沥青进行回收利用：",
        RecyclingRateOfWasteAsphalt: "废沥青回收利用率：",
        RecyclingRateOfWasteAsphaltPlaceholder: "废沥青回收利用率",
        recyclingTaxRefundSupportingDocuments:
          "上传对应的【回收利用退税证明文件/回收利用率计算书等】附件：",
        AsphaltProductEnergyConsumptionFile:
          "上传对应的【单位产品能源消耗计算书】附件：",
        greenLogisticsFile: "上传对应的【绿色物流认证证书】附件：",
        SmartWarehouseFile: "上传使用的【节能措施技术清单/设备清单】附件：",
        isSmartWarehouse: "是否使用了智能仓储管理技术：",
        isGreenPackaging: "是否对产品采用绿色包装：",
        isGreenPackagingFile: "上传对应的【绿色包装方案】附件：",
        isGreenTransportationMode: "是否对产品使用新能源车辆进行运输：",
        isGreenTransportationModeFile: "上传对应的【绿色物流运输方案】附件：",
        isGreenTransportationModeRating: "新能源车辆运输占比：",
        isGreenTransportationModeRatingPlaceholder: "新能源车辆运输占比",
        isTopLevelCarbonManagement: "是否制定顶层碳管理制度规划：",
        isTopLevelCarbonManagementFile: "上传相关的【碳管理制度规划】附件：",
        isCarbonEmissionReductionMeasures:
          "是否使用碳减排措施实现主体减排降碳：",
        isCarbonEmissionReductionMeasuresFile:
          "上传相关的【碳减排措施应用清单/新能源采购记录】附件：",
        isCarbonOffsetMeasures: "选择是否进行碳抵消：",
        isCarbonOffsetMeasuresFile: "上传对应的【碳抵消产品购买证书】附件："
      },
      inputPlc: {
        input: "请选择",
        cooperationCompanyMsg: "请选择本企业是否涉及绿色低碳管理",
        changeCategoryMsg: "请选择类别",
        isGreenProductionMsg: "请选择是否获得绿色工厂认证",
        isGreenLogistics: "请选择是否获得绿色物流认证",
        isEnterprisesPassTheCleanProductionAuditMsg:
          "请选择是否通过企业清洁生产审核",
        isZeroCarbonFactoryCertificationMsg: "请选择是否获得零碳工厂认证",
        greenFactoryCertificationLevelPlaceholderMsg: "请选择绿色工厂认证等级",
        isZeroCarbonFactoryCertificationRatingMsg: "请选择零碳工厂认证星级",
        isEnvironmentallyFriendlyProductionProcessMsg:
          "请选择是否使用新型干法等环保性生产工艺",
        isProductEnergyConsumptionMsg: "请输入轧钢单位产品能源消耗量",
        isAsphaltProductEnergyConsumptionMsg: "请输入沥青生产单位产品能源消耗",
        greenFactoryCertificationFileMsg:
          "请上传对应的【绿色工厂认证证书/铭牌】附件",
        ZeroCarbonFactoryCertificationRatingFile:
          "请上传对应的【零碳工厂认证证书/铭牌】附件",
        EnterprisesPassTheCleanProductionAuditFile:
          "请上传【清洁生产审核报告（备案本）】附件",
        EnvironmentallyFriendlyProductionProcessFile:
          "请上传对应的【生产工艺设计说明/流程说明】附件",
        ProductEnergyConsumptionFile:
          "请上传对应的【单位产品能源消耗计算书】附件",
        AsphaltProductEnergyConsumptionFile:
          "请上传对应的【单位产品能源消耗计算书】附件",
        AdoptingMethodsOfResourceRecyclingSuchAsRawMaterialSubstitutionMsg:
          "请选择是否采用原材料替代等资源循环利用方式",
        RawMaterialSubstitutionRateMsg: "原材料替代率",
        productionRawMaterialSubstitutionRate:
          "请上传上传对应的【生产原料替代率计算书】附件",
        ScrapSteelRecyclingPlanFile:
          "请上传对应的【废钢循环利用方案、计算书】附件",
        IsRecyclingOfRawMaterialsForAsphaltProductionConducted:
          "请选择是否对沥青生产原材料进行回收利用",
        RawMaterialRecyclingAndUtilizationRate: "请输入原材料回收利用率",
        CalculationSheetForRawMaterialRecyclingUtilizationRate:
          "请上传对应的【原材料回收利用率计算书】附件",
        IsWasteAsphaltRecycledAndReused: "请选择是否对废沥青进行回收利用",
        RecyclingRateOfWasteAsphalt: "请输入废沥青回收利用率",
        recyclingTaxRefundSupportingDocuments:
          "请上传对应的【回收利用退税证明文件/回收利用率计算书等】附件",
        isGreenProductionRating: "请选择绿色物流认证星级",
        SmartWarehouseFile: "请上传使用的【节能措施技术清单/设备清单】附件",
        isGreenPackaging: "请选择是否对产品采用绿色包装",
        isGreenPackagingFile: "请上传对应的【绿色包装方案】附件",
        isGreenTransportationMode: "请选择是否对产品使用新能源车辆进行运输",
        isGreenTransportationModeRating: "请输入新能源车辆运输占比",
        isGreenTransportationModeFile: "请上传对应的【绿色物流运输方案】附件",
        isTopLevelCarbonManagement: "请选择是否制定顶层碳管理制度规划",
        isTopLevelCarbonManagementFile: "请上传相关的【碳管理制度规划】附件",
        isCarbonEmissionReductionMeasures:
          "请选择是否使用碳减排措施实现主体减排降碳",
        isCarbonEmissionReductionMeasuresFile:
          "请上传相关的【碳减排措施应用清单/新能源采购记录】附件",
        isCarbonOffsetMeasures: "选择是否进行碳抵消",
        isCarbonOffsetMeasuresFile: "上传对应的【碳抵消产品购买证书】附件",
        isSmartWarehouse: "请选择是否使用了智能仓储管理技术",
        greenLogisticsFile: "上传对应的【绿色物流认证证书】附件",
      },
      table: {
        addBtn: "添加产品",
        isGreenProduction: "产品名称",
        isGreenProductionPlaceholder: "请选择产品名称",
        isGreenProductCertification: "是否获得绿色产品认证",
        greenProductCertificationRating: "绿色产品认证星级",
        greenProductCertificationRatingPlaceholder: "请选择绿色产品认证星级",
        greenProductCertificationFileName:
          "对应的【绿色产品认证证书/绿色产品标识】附件",
        ProductCarbonFootprintFileName:
          "对应的【产品碳足迹证书】或【产品碳足迹报告】附件",
        ProductCarbonFootprintFile:
          "上传对应的【产品碳足迹证书】或【产品碳足迹报告】附件",
        greenProductCertificationFile:
          "上传对应的【绿色产品认证证书/绿色产品标识】附件",
        ProductCarbonFootprintAccounting: "是否进行了产品碳足迹核算",
        ProductCarbonFootprintValue: "产品碳足迹数值（tCO2e/t）",
        ProductCarbonFootprintValuePlaceholder: "请输入产品碳足迹数值",
        operation: "操作",
        fileName:"附件名称",
        fileSize: "附件大小（KB）",
        preview: "预览",
        delete: "删除",
        view: "查看",
        download: "下载",
      },
      info:{
        upload1:"上传成功",
        cancel:"取消"
      }
    },
    qualificationFile: {
      contentTitle: { qualificationFile: "资质文件信息" },
      contentTitles: {
        hintMsg1: "提示：请上传原件扫描件，图片文件应小于",
        hintMsg2: "15",
        hintMsg3: "M,其他文件应小于",
        hintMsg4: "30M"
      },
      tableTh: {
        name: "附件名称",
        type: "附件类型",
        file: "文件",
        enclosureNotation: "附件说明",
        operation: "操作",
        input: "请输入",
        size: "附件大小"
      },
      tableTd: {
        businessLicense: "营业执照副本图片",
        identityCard: "法人代表身份证复印件",
        frameworkImg: "组织机构代码证图片",
        taxationImg: "税务登记证图片",
        taxationImg2: "(含增值税一般纳税人红章页面)",
        qualityControl: "质量管理体系认证证书",
        specialIndustry: "特殊行业资质证书图片",
        organizationChart: "组织架构及营销网络相关文件",
        companyQualification: "公司资质及荣誉文件",
        productionLicence: "生产许可证图片",
        distributiontImg: "经销代理资格证明图片",
        financialStatement: "财务报表(上年度经审计的财务报表)",
        cooperationFile: "合作业绩证明文件",
        businessLicenses: "经营许可证",
        environmentalManagement: "环境管理体系认证证书图片",
        healthySafety: "健康安全管理体系认证证书图片",
        otherFiles: "其他文件",
        transportation: "运输许可证(多张需合并上传)",
        img: "图片",
        file: "文件"
      },
      btn: { uploading: "上传", del: "删除" },
      info: {
        uploadErr1: "上传图片支持格式：.jpg .png .jpeg .gif .webp .pdf每个不超过15M",
        uploadErr2: "上传图片大小不能超过 15M!",
        uploadErr3: "上传文件支持格式：.xls .xlsx .doc .docx .pdf每个不超过30M",
        uploadErr4: "上传文件大小不能超过 30M!",
        delErr: "请先上传文件",
        subErr1: "营业执照副本图片不能为空",
        subErr2: "组织机构代码证图片不能为空",
        subErr3: "税务登记证图片不能为空",
        subErr4: "运输许可证文件不能为空",
        subErr5: "法人代表身份证复印件不能为空",
        sameFile: "请不要上传重名文件!",
        dialog1: "请确认所填信息的真实有效，您是否确定提交？",
        dialog2: "您已成功提交注册申请信息，请耐心等待",
        upload1: "文件上传成功"
      },
      file: {
        download: "下载",
        clickdownload: "点击下载",
        tip: "（含增值税一般纳税人红章页面）"
      }
    },
    mobileValidate: {
      title1: { name: "用户名", psd: "密码" },
      inputPlc: {
        mobile: "请输入手机号",
        name: "请输入用户名",
        psd: "请输入密码"
      },
      inputRules: {
        mobile: "请输入正确的手机号",
        code: "请输入六位数字验证码"
      },
      title: { title: "使用账号密码完成身份认证，查询注册审批进展" },
      btn: { code: "发送验证码", sub: "提交认证" },
      msg: {
        q: "收不到短信验证码？",
        a:
          "请检查手机网络并核实手机是否屏蔽系统短信，如均正常请重新获取或稍后再试。",
        msg1: "当前手机号未注册供应商"
      }
    },
    foreignSupRegDetail: {
      btn: { perfect1: "完善信息", recall: "撤回申请", perfect2: "修改信息" },
      msg: {
        msg1: "贵公司注册信息已开始由",
        msg2: "审批，不允许供应商撤回注册申请",
        msg3: "贵公司注册信息还未开始审批，确定要撤回注册申请吗？",
        msg4: "撤回申请成功",
        msg5: "已取消撤回申请"
      }
    },
    approval: {
      title: {
        title: "审批记录",
        title1: "说明",
        title2: "结论",
        title3: "意见"
      },
      msg: { msg1: "审批中", msg2: "暂无数据" }
    },
    validateMsg: {
      validateIDCard1: "联系人身份证校验异常",
      validateIDCard2: "法人人身份证校验异常",
      validateIDCard3: "销售人员身份证校验异常",
      validateIDCard4: "董监高人员身份证校验异常",
      validateIDCard5: "上传身份证信息与法人信息不匹配，请重新上传",
      validateIDCard6: "董监高人员证件类型必填"
    },
    // 英文 获取验证码
    validateEmail: {
      // 联系人邮箱不能为空 2025-12-11
      validateIDCard7: "联系人E-mail不能为空！",
      // 供应商名称不能为空！ 2025-12-11
      validateIDCard8: "供应商名称不能为空！",
      title: "拼图验证",
      title1: "换一张",
      title2: "拼图加载中...", // 拼图加载中
      title3: "向右滑动完成拼图",
      title4: "发送验证码"
    }
  },
  // 分包商注册
  subcontractor: {
    menuTitle: "分包商注册",
    menuTitle1: "中交集团分包电子采购共享平台",
    domestic: "境内分包商注册", // 境内分包商注册
    overseas: "境外分包商注册", // 境外分包商注册
    tipsTop: "海量商机，亿元市场", // 海量商机，亿元市场
    tipsBottom: "诚邀优质合作伙伴", // 诚邀优质合作伙伴
    registrationButton: "申请注册", // 申请注册
    authUserName: "注册联系人：", // 注册联系人
    subconUserName: "登录账号：", // 登录账号
    registerEmail: "注册人邮箱：", // 注册人邮箱
    emailPrompt: "该邮箱用于后续接收登录密码，请确保填写无误。", // 注册人邮箱提示
    cardType: "注册证件：", // 注册证件
    cardTypeOptions: {
      idCard: "身份证",
      passport: "护照",
      other: "其他"
    }, // 注册证件类型选项
    authPersonIdCard: "注册人证件号码：", // 注册人证件号码
    supplierName: "分包商名称：", // 分包商名称
    unifyCode: "统一社会信用代码：", // 统一社会信用代码
    phone: "注册手机号：", // 注册手机号
    verificationCode: "验证码：", // 验证码
    miaoBtn: " 秒", // 秒
    sendBtn: "发送", // 发送
    confirmBtn: "确 定", // 确 定
    dialogTitle: "选择合作单位", // 选择合作单位
    
    placeholderTip: {
      cardTypePlc: "请选择证件类型", // 注册证件提示
      authPersonIdCardPlc: "请输入注册人证件号码" // 注册人证件号码提示
    },
    verifyTip: {
      authUserName: "请输入注册联系人", // 请输入注册联系人
      authUserNameVerify: "请输入2-18个中文汉字", // 请输入2-18个中文汉字
      subconUserNameVerify: "登录账号不允许包含中文", // 登录账号不允许包含中文
      phone: "请输入注册手机号", // 请输入注册手机号
      phoneVerify: "手机号码输入错误", // 手机号码输入错误
      registerEmail: "请输入注册人邮箱", // 请输入注册人邮箱
      registerEmailVerify: "只支持输入邮箱格式", // 只支持输入邮箱格式
      cardType: "请选择注册证件", // 请选择证件类型
      authPersonIdCard: "请输入注册人证件号码", // 请输入注册人证件号码
      authPersonIdCardVerify: "请输入正确的证件号码", // 请输入正确的证件号码
      supplierName: "请输入分包商名称", // 请输入分包商名称
      unifiedCreditCode: "请输入统一社会信用代码", // 请输入统一社会信用代码
      unifiedCreditCodeVerify: "长度为18位", // 长度为18位
      cooUnitName: "请输入合作单位", // 请输入合作单位
      verificationCode: "请输入验证码", // 请输入验证码
      emailVerify: "请输入正确的注册人邮箱", // 请输入正确的注册人邮箱
      sendPhoneTip: "手机号码不正确", // 手机号码不正确
      subconUserNameTip: "请输入登录账号" // 请输入登录账号
    },
    submitVerifyTip: {
      submitTip: "请完善信息" // 请完善信息
    },
    subconSubmitSuccess: {
      menuTitle1: "中交集团分包电子采购共享平台", // 中交集团分包电子采购共享平台
      messageOne: "您已成功注册交建云商，请", // 您已成功注册交建云商，请
      messageTwo: "点击登陆", // 点击登陆
      messageThree: "进行信息维护", // 进行信息维护
      messageFour: "注:如您在注册成功后七天内未完成信息完善，您的账号将被注销，需重新进行注册，请及时完善信息" // 注:如您在注册成功后七天内未完成信息完善，您的账号将被注销，需重新进行注册，请及时完善信息
    }
  }
};
